import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { CourseDiscountItem } from "./CourseDiscountItem";
import { getCourseDiscountData } from "../services/courseService";

export default function CourseDiscountList({ style, title, actionLabel }) {
  const [discountData, setDiscountData] = useState([]);

  useEffect(() => {
    const fetchCourseDiscountData = async () => {
      const data = await getCourseDiscountData();
      setDiscountData(data);
    };
    fetchCourseDiscountData();
  }, []);

  return (
    <div className="course-discount-list-component" style={style}>
      <div className="flex justify-content-between mb-1rem course-discount-list-component-title">
        <h1 className="text-default-text-color font-weight-700 font-size-36 light-height-40">
          {title}
        </h1>
        <Button
          label={actionLabel}
          link
          className="primary-color font-weight-700 font-size-20 line-height-28 none-focus-outline-btn p-0"
        />
      </div>
      <div className="course-discount-list-wrapper">
        {discountData.map((item, index) => (
          <div key={index} className="course-discount-wrapper-item">
            <CourseDiscountItem key={item?.id} discountItem={item} />
          </div>
        ))}
      </div>
    </div>
  );
}
